export default {
    DIRECT: 'Direct',
    EMAIL: 'Email',
    ORGANIC: 'Organic',
    PAID: 'Paid',
    REFERRAL: 'Referral',
    SOCIAL: 'Social',
};
